<template>
  <div>
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2
        class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
      >
        Log In
      </h2>
    </div>
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <form @submit.prevent="login">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div>
            <WwpLabel>Email</WwpLabel>
            <div class="mt-1 rounded-md shadow-sm">
              <WwpInput v-model="email"></WwpInput>
            </div>
          </div>
          <div class="mt-6">
            <WwpLabel>Password</WwpLabel>
            <div class="mt-1 rounded-md shadow-sm">
              <WwpInput v-model="password" type="password"></WwpInput>
            </div>
          </div>
          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <button
                class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
              >
                Sign in
              </button>
            </span>
          </div>
          <div class="mt-6">
            <span class="text-blue-600 cursor-pointer" @click="lostPassword"
              >Lost Password?</span
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import WwpInput from "../ui/forms/BaseInput";
import WwpLabel from "../ui/forms/BaseLabel";

export default {
  name: "Login",
  components: {
    WwpLabel,
    WwpInput,
  },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    lostPassword() {
      this.$router.push("/lost-password");
    },
    login() {
      const data = {
        email: this.email,
        password: this.password,
      };
      this.$store.dispatch("auth/login", data).then((resp) => {
        if (!resp.success) return;

        this.$notify({
          title: "Login",
          message: "Login Successful",
          type: "success",
        });
        const user = this.$store.getters["auth/getUser"];
        if (user.role === "admin") {
          this.$router.push("/admin");
        } else if (user.role === "outfitter") {
          this.$router.push("/dashboard");
        } else if (user.role === "employee") {
          this.$router.push("/dashboard/pending-orders");
        } else if (user.role === "photographer") {
          this.$router.push("/photographer");
        } else {
          window.location.href = "/";
        }
      });
    },
  },
};
</script>
